import { useEffect, useState } from 'react';

import { api } from '@/context/AuthContext';

export const useOutrosEncontrosViewModel = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get('/eventos-especiais')
      .then(({ data }) => setEventos(data || []))
      .catch(() => setEventos([]))
      .finally(() => setLoading(false));
  }, []);

  return { eventos, loading };
};
